import { makeStyles } from "@material-ui/core/styles";
import clsx from 'clsx';
import UtilService from "../../../../../helper/service";
import { useSelector } from "react-redux";

const useStyles = makeStyles(() => ({

  container0: {
    width: '100%',
    display: 'flex',
    position: 'relative',
    marginBottom: 1,
  },

  container1: {
    display: 'flex',
    width: '100%',
    margin: '0 30px',
    overflowX: 'auto',
    justifyContent: 'center'
  },

  container: {
    maxWidth: '100%',
    height: 300,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end'
  },

  barContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },

  normContainer: {
    width: '100%',
    height: 40,
    padding: '0 8px',
    position: "absolute",
    // transform: 'translateY(50%)',
    display: 'flex',
    alignItems: 'center',
  },

  lineNorm: {
    borderBottom: '3px dashed #017AEF',
    opacity: '35%',
    flex: 1,
    marginLeft: 7,
  },

  imgDiamond: {
    width: 8,
    height: 8,
    marginBottom: 4
  },

  imgNorm: {
    width: 20,
    height: 20,
  },

  barDate: {
    height: 16,
    minHeight: 16,
    color: '#697683',
    fontFamily: 'roboto-bold',
    fontSize: 12,
    // marginBottom: 10,
    textAlign: 'center'
  },

  bar: {
    width: 96,
    minWidth: 96,
    // height: '100%',
    // background: '#1DB859',
    color: 'white',
    margin: '0 20px',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '10px 10px 10px 10px',
    textAlign: 'center'
  },
  barRed: {
    background: '#ED564A',
  },
  barGreen: {
    background: '#1DB859',
  },
  barGray: {
    background: '#8192A2',
  },

  textScore: {
    fontFamily: 'Spartan-Bold',
    fontWeight: 'bold',
    fontSize: 22
  },
  textTitle: {
    fontFamily: 'roboto-bold',
    fontSize: 9
  },



}));


function CompareBar(props: any) {

  const classes = useStyles();
  const { sessions, immersionNorm, safetyNorm, category } = props;

  return (
    <div className={classes.container0} >

      {(immersionNorm || safetyNorm) &&
        <div className={classes.normContainer} style={{ bottom: `calc((100% - 28px + 4px) * ${(category === 'immersion' ? immersionNorm : safetyNorm) / 100})` }}>
          <img className={classes.imgNorm} src={'/assets/icons/compare/icon_norm.svg'} alt={'img'} />
          <span className={classes.lineNorm} />
        </div>
      }

      <div className={classes.container1} >
        <div className={clsx(classes.container)}>
          {
            sessions.filter((item: any) => {
              return item.session_code !== 'industry_norm'
            })
              .map((item: any, index: number) => {
                return (
                  <Bar
                    key={index}
                    item={item}
                    immersionNorm={immersionNorm}
                    safetyNorm={safetyNorm}
                    category={category}
                  />
                )
              })
          }
        </div>
      </div>
    </div>

  )
}

export default CompareBar;


function Bar(props: any) {

  const classes = useStyles();
  const { item, category } = props;
  const currentSessionId = localStorage.getItem("session_id") ? localStorage.getItem("session_id") : "";

  const { sessions } = useSelector((state: any) => state.experience);

  const isClipped = (session: any) => {
    if (!session) return false;

    return (String(session.session_id).includes('clip-'));
  }

  const getSessionDate = (item: any) => {

    if (isClipped(item)) {
      const parentSession = sessions.find((session: any) => (!isClipped(session) && (item.session_code === session.session_code)));
      return parentSession ? UtilService.getSimpleDate(parentSession.start) : UtilService.getSimpleDate(new Date().getTime());
    } else {
      return UtilService.getSimpleDate(item.start);
    }

  }

  const getImmersionValue = (item: any) => {

    const immersion = item.immersion;
    if (!immersion) return 0;
    return immersion;
  }

  const getSafetyValue = (item: any) => {

    const safety = item.safety;
    if (!safety) return 0;
    return safety;
  }

  const getValue = (item: any) => {
    return Number(category === 'immersion' ? getImmersionValue(item) : getSafetyValue(item));
  }

  const checkPrimary = (item: any) => {
    return (String(currentSessionId) === String(item.session_id)) && item.session_code !== 'industry_norm';
  }

  return (
    <div className={clsx(classes.barContainer)}>
      {
        checkPrimary(item) &&
        <img className={classes.imgDiamond} src={'/assets/icons/compare/icon_diamond.svg'} alt={'img'} />
      }

      <div className={clsx(classes.barDate)}>{getSessionDate(item)}</div>
      <div
        className={clsx(
          classes.bar,
          UtilService.getColorFromSessionWithCategory(item, category) === 'green' && classes.barGreen,
          UtilService.getColorFromSessionWithCategory(item, category) === 'gray' && classes.barGray,
          UtilService.getColorFromSessionWithCategory(item, category) === 'red' && classes.barRed,
        )}
        style={{ height: `${getValue(item)}%`, minHeight: `22%` }}
      >
        <div className={classes.textScore}>{(String(getValue(item)) === '1' || String(getValue(item)) === '0') ? '-' : getValue(item)}</div>
        <div className={clsx(classes.textTitle, 'line-clamp-2')}>{item.name}</div>
      </div>
    </div>

  )
}